export const assignRoles = (players, civilianCount, imposterCount, mrWhiteCount, wordPair) => {
  console.log('=== ASSIGN ROLES DEBUG ===');
  console.log('Word Pair:', wordPair);
  console.log('Civilian Count:', civilianCount, 'Imposter Count:', imposterCount, 'Mr White Count:', mrWhiteCount);
  console.log('Total players:', players.length);
  
  // Create an array of roles with explicit word assignment
  const roles = [];
  
  // Add civilians with civilian word
  for (let i = 0; i < civilianCount; i++) {
    const civilianRole = { 
      role: 'civilian', 
      word: wordPair.civilian 
    };
    console.log(`Adding civilian ${i+1}:`, civilianRole);
    roles.push(civilianRole);
  }
  
  // Add imposters with imposter word
  for (let i = 0; i < imposterCount; i++) {
    const imposterRole = { 
      role: 'imposter', 
      word: wordPair.imposter 
    };
    console.log(`Adding imposter ${i+1}:`, imposterRole);
    roles.push(imposterRole);
  }
  
  // Add Mr. White with no word
  for (let i = 0; i < mrWhiteCount; i++) {
    const mrWhiteRole = { 
      role: 'mrwhite', 
      word: null 
    };
    console.log(`Adding Mr. White ${i+1}:`, mrWhiteRole);
    roles.push(mrWhiteRole);
  }
  
  console.log('Roles BEFORE shuffle:', JSON.stringify(roles));
  
  // Shuffle using Fisher-Yates algorithm
  const shuffledRoles = [...roles];
  for (let i = shuffledRoles.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const temp = shuffledRoles[i];
    shuffledRoles[i] = shuffledRoles[j];
    shuffledRoles[j] = temp;
  }
  
  console.log('Roles AFTER shuffle:', JSON.stringify(shuffledRoles));
  
  // Assign shuffled roles to players
  const result = players.map((player, index) => {
    const assignedRole = shuffledRoles[index];
    const playerWithRole = {
      ...player,
      role: assignedRole.role,
      word: assignedRole.word,
    };
    console.log(`Player ${index + 1} (${player.name}):`, playerWithRole);
    return playerWithRole;
  });
  
  console.log('=== ASSIGNMENT COMPLETE ===');
  
  return result;
};

export const checkWinCondition = (players) => {
  const activePlayers = players.filter(p => !p.isEliminated);
  const activeCivilians = activePlayers.filter(p => p.role === 'civilian');
  const activeImposters = activePlayers.filter(p => p.role === 'imposter');
  const activeMrWhite = activePlayers.filter(p => p.role === 'mrwhite');

  if (activeImposters.length === 0 && activeMrWhite.length === 0) {
    return { winner: 'civilians', message: 'Civilians Win! All threats eliminated!' };
  }

  if (activeImposters.length >= activeCivilians.length && activeMrWhite.length === 0) {
    return { winner: 'imposters', message: 'Imposters Win! They control the game!' };
  }

  if (activeMrWhite.length > 0 && activeCivilians.length + activeImposters.length <= 1) {
    return { winner: 'mrwhite', message: 'Mr. White Wins! He survived to the end!' };
  }

  return null;
};

export const calculateVoteResult = (players) => {
  const voteCounts = {};
  const activePlayers = players.filter(p => !p.isEliminated);
  
  activePlayers.forEach(player => {
    if (player.vote) {
      voteCounts[player.vote] = (voteCounts[player.vote] || 0) + 1;
    }
  });

  const maxVotes = Math.max(...Object.values(voteCounts));
  const playersWithMaxVotes = Object.keys(voteCounts).filter(id => voteCounts[id] === maxVotes);

  if (playersWithMaxVotes.length === 1) {
    return playersWithMaxVotes[0];
  }

  const randomIndex = Math.floor(Math.random() * playersWithMaxVotes.length);
  return playersWithMaxVotes[randomIndex];
};
